module.exports = __webpack_public_path__ + "img/icon-eoi.49cce98e.svg";